import { create } from "zustand";

interface DashboardRefreshState {
  updatedAt: number;
  refreshIn: number;
  isRefreshing: boolean;
  refresh: (() => void) | null;
  setRefreshState: (state: {
    updatedAt: number;
    refreshIn: number;
    isRefreshing: boolean;
    refresh: () => void;
  }) => void;
  clearRefreshState: () => void;
}

export const useDashboardRefreshStore = create<DashboardRefreshState>(
  (set) => ({
    updatedAt: 0,
    refreshIn: 30,
    isRefreshing: false,
    refresh: null,
    setRefreshState: (state) => set(state),
    clearRefreshState: () => set({
      updatedAt: 0,
      refreshIn: 30,
      isRefreshing: false,
      refresh: null,
    }),
  }),
);
